import { useAdd, KnowledgeType } from '@uds/reactive-knowledge';
import { useIntl } from 'react-intl';

export type ShowToast = (messageId: string, type?: KnowledgeType) => void;

export default function useShowToast(): ShowToast {
  const add = useAdd();
  const intl = useIntl();
  return (message: string, type: KnowledgeType = KnowledgeType.SMIRK) => {
    add({
      type,
      message: intl.formatMessage({ id: message }),
    });
  };
}
